import { render } from "./AlertHeader.vue?vue&type=template&id=6376da16&scoped=true"
import script from "./AlertHeader.vue?vue&type=script&lang=js"
export * from "./AlertHeader.vue?vue&type=script&lang=js"

import "./AlertHeader.vue?vue&type=style&index=0&id=6376da16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6376da16"]])

export default __exports__